import React, { useEffect, createElement } from 'react';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function ClosingCTA() {
  useEffect(() => {
    // Load HubSpot forms script
    const script = document.createElement('script');
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      // @ts-ignore
      if (typeof hbspt !== 'undefined') {
        // @ts-ignore
        hbspt.forms.create({
          portalId: '51051096',
          formId: '394c68f4-dba7-4779-977b-5c4c697340e2',
          region: 'na1',
          target: '#hubspot-form-container'
        });
      }
    };
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section id="contact-form" className="bg-gray-50 dark:bg-black py-20" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-97">
          <div data-id="element-98">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-99">
              Ready to Transform Your
              <span className="block text-blue-600 dark:text-brand-green" data-id="element-100">
                Device Trade-In Business?
              </span>
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8" data-id="element-101">
              Join thousands of satisfied retailers and customers who are
              optimizing their trade-in programs with our AI-powered platform.
              Schedule a demo today and see how we can help you increase revenue
              and streamline operations.
            </p>
            <div className="space-y-4 mb-8" data-id="element-102">
              {['Custom-tailored solutions for your business', 'Full platform demo with our product experts', 'ROI analysis and implementation roadmap', 'Competitive pricing and flexible plans'].map((feature, index) => <div key={index} className="flex items-start" data-id="element-103">
                  <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green mr-2 mt-0.5 flex-shrink-0" data-id="element-104" />
                  <span className="text-gray-700 dark:text-gray-300" data-id="element-105">
                    {feature}
                  </span>
                </div>)}
            </div>
            <div className="flex items-center space-x-4" data-id="element-106">
              <Button className="bg-blue-600 dark:bg-brand-green text-white dark:text-black px-8 py-3 rounded-full hover:bg-blue-700 dark:hover:bg-brand-green/90" data-id="element-107">
                Schedule Demo
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-108" />
              </Button>
              <span className="text-sm text-gray-500" data-id="element-109">
                or call us at{' '}
                <a href="tel:+55 21 97301-6996" className="text-blue-600 dark:text-brand-green font-medium" data-id="element-110">
                  +55 21 97301-6996
                </a>
              </span>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-900 rounded-xl p-8 border border-gray-200 dark:border-gray-800 shadow-lg" data-id="element-111">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-112">
              Get Started Today
            </h3>
            <div id="hubspot-form-container" className="[&_input]:!bg-white dark:[&_input]:!bg-gray-800 [&_input]:!text-gray-900 dark:[&_input]:!text-white [&_textarea]:!bg-white dark:[&_textarea]:!bg-gray-800 [&_textarea]:!text-gray-900 dark:[&_textarea]:!text-white [&_label]:!text-gray-700 dark:[&_label]:!text-gray-300" data-id="element-113" />
          </div>
        </div>
      </div>
    </section>;
}